import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { AuthLanguageDetector } from "@monorepo/libraries";

import resources from "./locales";

const LngDetector = new LanguageDetector();
LngDetector.addDetector(new AuthLanguageDetector());

i18n
  .use(LngDetector)
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: "en",
    debug: false,
    defaultNS: "app",
    ns: ["signIn", "signUp", "reset"],

    detection: {
      order: ["auth", "querystring"]
    },

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
      format (value, format) {
        if (format === "percentage") return `${value}%`;
        return value;
      }
    },

    resources
  });

export default i18n;
